import View from './View'

const Container = ({ register, errors }) => (
  <View title="Cadastro Unidade" register={register} errors={errors} />
)

export default Container
